module.exports = __webpack_public_path__ + "static/img/插花艺术观赏性软件.aa6b4cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/插花艺术观赏性软件.jpg
// module id = L/Li
// module chunks = 15